<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!Setting.isForm" flat class="pa-2 text-no-wrap">
        <v-typeSetting v-model="type" @change="_findOne" />
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0">
      <v-dialogEvent v-if="show == 'event'" />
      <v-dialogDiscovery v-if="show == 'discovery'" />
    </v-col>
  </v-layout>
</template>

<script>
import DialogEvent from "./dialogEvent.vue";
import DialogDiscovery from "./dialogDiscovery.vue";

export default {
  components: {
    "v-dialogEvent": DialogEvent,
    "v-dialogDiscovery": DialogDiscovery,
  },
  data() {
    return {
      model: "Setting",
      type: "",
      show: "",
    };
  },
  methods: {
    async _findOne() {
      const { code } = await this.fnGet({
        url: `/v1/admin/setting/${this.type}`,
        model: this.model,
      });
      if (code === 200) {
        if (this[this.model].obj.opt.dateRange) {
          this[this.model].obj.opt.dateRange = this[
            this.model
          ].obj.opt.dateRange.map((e) => this.$moment(e).unix());
        }
        if (this[this.model].obj.opt.activeDates) {
          this[this.model].obj.opt.activeDates = this[
            this.model
          ].obj.opt.activeDates.map((e) => this.$moment(e).unix());
        }
        this.show =
          this.type == "6192083be1474df2106ba142" ? "event" : "discovery";
      }
    },
  },
};
</script>
